import { States } from '../../../../../../constants';

export const validStateOptions: string[] = [];
States.forEach((state) => {
  validStateOptions.push(state.name);
});

export const gender = ['Male', 'Female'];

export const maritalStatus = ['Married', 'Un-Married', 'Widowed'];

export const races = ['African-American', 'Caucasian', 'Hispanic', 'Other'];

export const acquisitionTypeOptions = ['Off-Market', 'On-Market', 'Joint venture with land owner', 'Other'];

export const siteControlStatusOptions = [
  'LOI Obtained',
  'Purchase Contract Executed',
  'RFP Submitted',
  'Exclusive Negotiating Period Entered Into',
  'Other',
];

export const projectByRightOptions = ['Yes', 'No', 'Not Yet Determined'];
